<template>
  <div v-bind="$attrs" :class="{ 'has-error': error }">
    <div class="flex w-full flex-row justify-between">
      <div
        v-if="label || $scopedSlots.label"
        class="mb-2 flex-1 text-xs font-semibold uppercase text-gray-600"
        @click="isCollapsed = !isCollapsed"
      >
        <slot name="label">
          {{ label }}
        </slot>

        <div v-if="tooltip" v-tippy :content="tooltip" role="button" class="inline-block text-xs text-gray-500">
          <i class="fas fa-question-circle" />
        </div>
      </div>
      <div v-if="collapsable">
        <button
          v-if="collapsable"
          type="button"
          class="mb-2 flex items-center justify-center p-0 pb-2 text-xs"
          @click="isCollapsed = !isCollapsed"
        >
          <Icon :name="isCollapsed ? 'chevron-up' : 'chevron-down'" class="collapse-icon h-2 w-2 text-gray-700" />
        </button>
      </div>
    </div>
    <div v-show="!collapsable || isCollapsed" :class="[slotClass, { 'flex-row': horizontal }]">
      <slot />
    </div>
    <div v-if="collapsable && !isCollapsed" class="my-4 w-full border-t border-gray-200"></div>
    <div v-if="error" class="mt-1 text-xs text-red-500" v-text="error" />
    <div v-if="message" class="p-1 text-xs">
      {{ message }}
    </div>
  </div>
</template>

<script>
import { isComponent } from '../utils/component'

export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: null,
    },
    tooltip: {
      type: String,
      default: null,
    },
    slotClass: {
      type: String,
      default: '',
    },
    collapsable: {
      type: Boolean,
      default: false,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCollapsed: this.collapsable ? this.collapsed : false,
    }
  },
  computed: {
    error() {
      const form = this.findForm(this.$parent)
      if (this.name && form) {
        return form.error(this.name)
      }

      return null
    },
  },
  methods: {
    findForm(vm) {
      if (isComponent(vm, '<Form>')) {
        return vm
      }

      return vm.$parent ? this.findForm(vm.$parent) : null
    },
  },
}
</script>

<style lang="scss">
.has-error {
  input,
  .border {
    border-color: theme('colors.red.500') !important;
  }
}

.hide-this {
  display: none;
}
</style>
